import {
    DatiqCellHeaderSortBy,
    DatiqCellHeaderSortByType,
} from './datiq-cell-header-sort.enum';

import { z } from 'zod';

export const DatiqCellHeaderSortSchema = z.object({
    label: z.string(),
    sortBy: z.nativeEnum(DatiqCellHeaderSortBy),
    disabled: z.boolean().optional(),
    data: z.unknown().optional(),
    type: z.nativeEnum(DatiqCellHeaderSortByType).optional(),
    id: z.string().optional(),
    align: z.string().optional(),
    longHeader: z.boolean().optional(),
});
export interface IDatiqCellHeaderSort
    extends z.infer<typeof DatiqCellHeaderSortSchema> {}

export interface IDatiqSort {
    key: string;
    sortBy: DatiqCellHeaderSortBy;
}
